/*
 * @Author: shenlijian@ihuyue.cn
 * @Date: 2024-08-19 09:33:08
 * @LastEditors: shenlijian
 * @LastEditTime: 2024-08-30 09:26:13
 * @Description: 
 */
import axios from './axios.js'

const baseURL = 'https://gw.app.universalbeijingresort.com/'; // 生产
// const baseURL = 'https://tgw.app.universalbeijingresort.com/test/'; // 测试

export const GetNewsList = (params) => {
  return axios.request({
    url: baseURL + 'h5/user_location',
    method: 'get',
    crossDomain: true, //设置跨域为true
    params: params,
  })
}
export const GetDownloadurl = (params) => {
  return axios.request({
    url: baseURL + 'h5/download/url',
    method: 'get',
    crossDomain: true, //设置跨域为true
    params: params,
  })
}
